import React from 'react';
import Image from 'next/image';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import calenderIcon from '../../../public/assets/calenderIcon.png';
import clockIcon from '../../../public/assets/clockIcon.png';
import map from '../../../public/assets/map.png';

function DatePlace({
  startDate,
  endDate,
  venue = '',
}) {
  return (
    <div className="grid grid-cols-2 md:gap-2 gap-2">
      <div className="col-span-1 h-auto rounded-[8px] border border-[#8dcaff] xl:px-[24px] lg:px-[20px] py-[18px] bg-[#fff] px-2 flex md:items-center items-center justify-start">
        <div className="relative shrink-0 md:w-[30px] md:h-[30px] w-[22px] h-[22px]">
          <Image src={calenderIcon} fill alt="icon" />
        </div>
        {/* md:text-[21px] text-[18px] */}
        <div className="lg:ps-2 xl:ps-5 ps-[0.5rem] flex flex-col items-start">
          <span className="font-[700] xl:text-xl lg:text-xl md:text-lg text-base md:leading-[20px] leading-6 text-[#282938]">Date</span>
          <span className="font-[300] md:leading-[26px] leading-[20px] md:text-[14px] text-[12px] text-[#282938] inline-block">{format(startDate, 'do MMM yyyy')}</span>
        </div>
      </div>
      <div className="col-span-1 h-auto rounded-[8px] border border-[#8dcaff] xl:px-[24px] lg:px-[20px] py-[18px] bg-[#fff] flex md:items-center items-center px-2 justify-start">
        <div className="relative shrink-0 md:w-[30px] md:h-[30px] w-[22px] h-[22px]">
          <Image src={clockIcon} fill alt="icon" />
        </div>
        <div className="lg:ps-2 xl:ps-5 ps-[0.5rem] flex flex-col items-start">
          <span className="font-[700] xl:text-xl lg:text-xl md:text-lg text-base md:leading-[20px] leading-6 text-[#282938]">Time</span>
          <span className="font-[300] md:leading-[26px] leading-[20px] md:text-[14px] text-[12px] text-[#282938] inline-block">{`${format(startDate, 'hh:mm a')} to ${format(endDate, 'hh:mm a')}`}</span>
        </div>
      </div>
      {
        venue && venue !== 'Online' && (
        <div className="col-span-2 h-auto rounded-[8px] border border-[#8dcaff] xl:px-[24px] px-2 lg:px-[20px] py-[18px] bg-[#fff] flex md:items-center items-start justify-center">
          <div className="relative shrink-0 md:w-[50px] md:h-[50px] w-[40px] h-[40px]">
            <Image src={map} fill alt="icon" />
          </div>
          <div className="lg:ps-2 xl:ps-5 ps-[0.5rem] flex flex-col items-start">
            <span className="font-[700] xl:text-xl lg:text-xl md:text-lg text-base md:leading-[20px] leading-6 text-[#282938]">Venue</span>
            <span className="font-[300] md:leading-[26px] leading-[20px] md:text-[14px] text-[12px] text-[#282938] inline-block">{venue}</span>
          </div>
        </div>
        )
      }
    </div>
  );
}
DatePlace.propTypes = {
  startDate: PropTypes.number.isRequired,
  endDate: PropTypes.number.isRequired,
  venue: PropTypes.string,
};
export default DatePlace;
